import { FC } from 'react'
import styled, { css } from 'styled-components'
import { Button } from './Button'

type Props = {
  page: number
  limit: number
  goNext: () => void
  goBack: () => void
  count: number
  total: number
}

export const PageNation: FC<Props> = ({ page, limit, goNext, goBack, count, total }) => {
  const currentTotal = count + limit * (page - 1)
  return (
    <>
      <div
        css={css`
          text-align: right;
          margin-top: 10px;
        `}
      >
        {count !== 0 && <>{page === 1 ? '1' : limit * (page - 1) + 1}~</>}
        {currentTotal}件
      </div>
      <StyledButtonWrap>
        <Button onClick={goBack} buttonType="contained" disabled={page === 1}>
          前へ
        </Button>
        <Button
          onClick={goNext}
          buttonType="contained"
          disabled={currentTotal >= total - limit && total <= currentTotal}
        >
          次へ
        </Button>
      </StyledButtonWrap>
    </>
  )
}

const StyledButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  button {
    margin: 0 10px;
  }
`
